export default __webpack_public_path__ + "static/media/fontainebleau6.74698882.jpg";